import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core';

//////////////////////////

const Route1Heading = props => {

  const theme = useTheme();

  return ( <>
    <Typography
      variant = "h1"
      style = {{
        color: theme.palette.primary.contrastText,
      }}
      >
      Route 1
    </Typography>
  </> );
  
};

export default Route1Heading;
